export default "__VITE_ASSET__8f17fd7b__"